import * as React from 'react';

const PRICE_SUFFIX_ID = 'price-note';
const PriceSuffix = ()=>{
    return /*#__PURE__*/ React.createElement("a", {
        href: `#${PRICE_SUFFIX_ID}`,
        className: "v2-product-block-price-suffix"
    }, "*");
};

export { PRICE_SUFFIX_ID, PriceSuffix };
//# sourceMappingURL=PriceSuffix.js.map
